import './accordion.scss';
import 'nodelist-foreach-polyfill';
import { Foundation } from 'foundation-sites/dist/js/plugins/foundation.core';
import { Keyboard } from 'foundation-sites/dist/js/plugins/foundation.util.keyboard';
import { Accordion } from 'foundation-sites/dist/js/plugins/foundation.accordion';

Foundation.Keyboard = Keyboard;
Foundation.plugin(Accordion, 'Accordion');

document.addEventListener('DOMContentLoaded', () => {
  Foundation.addToJquery($);
  $(document).foundation();
});
